import React, { useState } from 'react'
import { Modal, Button, InputGroup, Form } from 'react-bootstrap';
import { insertTableBd } from '../../config/functions'
import { toast } from 'react-toastify'

const ModalOperadora = ({ show, handleClose, setRecargar, getOperadoras }) => {

    const [nombre, setNombre] = useState('')
    const user = JSON.parse(localStorage.getItem("token")).userName;

    //-----------------------------------------------------

    const guardarNueva = async () => {
        if (!nombre.trim()) {
            toast.warning('El nombre no puede estar vacío.');
            return;
        }

        const dataToSend = {
            operadora: nombre.toLocaleUpperCase(),
            usuario_modifico: user,
        };

        try {
            await insertTableBd('createoperadora', dataToSend, dataToSend);
            toast.success(`Operadora guardada exitosamente.`);
            await getOperadoras();
            setRecargar(true)
            handleClose();
        } catch (error) {
            toast.error('Error al guardar los datos.');
        }
    }

    //------------------------------------------------------

    return (
        <Modal show={show} onHide={handleClose} id="alarmModal" aria-labelledby="alarmModalLabel">

            <Modal.Header closeButton>
                <Modal.Title> Adicionar Operadora </Modal.Title>
            </Modal.Header>

            <Modal.Body>

                <InputGroup className="mb-3" size="sm">
                    <InputGroup.Text >operadora</InputGroup.Text>
                    <Form.Control
                        type="text"
                        aria-label='operadora'
                        placeholder='operadora'
                        size="sm"
                        onChange={(e) => setNombre(e.target.value)}
                        value={nombre} />
                </InputGroup>

            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={guardarNueva}>
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalOperadora